"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toTitleCase = toTitleCase;
/**
 * Converts a string to title case (first letter of each word capitalized).
 * Useful for normalizing names from different sources (e.g. DIGITAL_TWIN vs manual entry).
 */
function toTitleCase(str) {
    return str.toLowerCase().replace(/\b\w/g, function (c) { return c.toUpperCase(); });
}
